export let ViewType = /*#__PURE__*/function (ViewType) {
  ViewType["EnterOneTimePassword"] = "EnterOneTimePassword";
  ViewType["SetUpNewEmail"] = "SetUpNewEmail";
  ViewType["TooManyAttempts"] = "TooManyAttempts";
  ViewType["VerifyNewEmail"] = "VerifyNewEmail";
  return ViewType;
}({});
export const changeEmailErrorMessages = {
  emailAlreadyRegistered: 'Email already exists. To grant this user access to a business, please add them as a team member.',
  somethingWentWrong: 'Something went wrong.',
  otpCodeIsInvalid: 'Code is invalid. Please try again.'
};
export const changeEmailSuccessMessages = {
  emailChanged: 'Email address successfully changed'
};